<template>
  <div class="head-conter-box">
    <div class="content_box">
      <div class="logo-box" @click="handleOpen('/home')">
        <img :src="`${this.$baseUrl}images/logo.png`" alt="">
        <span>浙立保</span>
      </div>
      <el-menu
        :default-active="activeIndex"
        class="el_menu_box move_none"
        :router="true"
        mode="horizontal"
        active-text-color="#167FFF"
        text-color="#1D2129"
        @select="handleSelect"
      >
        <el-menu-item v-for="(item, index) in navList" :key="index + 'nav'" :index="item.routerName" @mouseleave.native="handleMouseLeave(item)" @mouseover.native="handleMouseOver(item)">{{ item.name
        }}</el-menu-item>
        <base-navigation v-if="isShowNav" :nav-item="navItem" @changeNav="changeNav" />
      </el-menu>
      <div class="move_display">
        <i v-show="isMouseShowNav" @click="changMouseNav(false)" class="el-icon-close head-menu"></i>
        <img v-show="!isMouseShowNav" @click="changMouseNav(true)" :src="`${this.$baseUrl}images/icon-threeHorizontal.png`" alt="" class="head-menu">
      </div>
    </div>
    <!-- 新增移动端导航栏 -->
    <div v-if="isMouseShowNav" class="mouseNav-box">
      <el-menu
        :default-active="activeIndex"
        class="mouse-menu"
        @select="handleOpen">
        <div v-for="(item, index) in navList" :key="index + 'nav'" :index="item.routerName">
          <div v-if="item.navList?.length">
            <el-submenu :index="item.routerName">
              <span slot="title">{{ item.name }}</span>
              <el-menu-item-group>
                <el-menu-item v-for="(childItem, childIndex) in item.navList" :key="childIndex + 'childNav'" :index="childItem.type">{{ childItem.name }}</el-menu-item>
              </el-menu-item-group>
            </el-submenu>
          </div>
          <div v-else>
            <el-menu-item :index="item.routerName">
              <span slot="title">{{ item.name }}</span>
            </el-menu-item>
          </div>
        </div>
      </el-menu>
    </div>
  </div>
</template>
<script>
import BaseNavigation from '@/components/base/BaseNavigation.vue'

export default {
  name: 'Head',
  components: { BaseNavigation },
  data() {
    return {
      navList: [
        { name: '首页', routerName: '/home' },
        { name: '业务介绍', routerName: '', routerUrl: '/businessIntroduction', navList: [{ name: '履约保函', type: 'performance' }, { name: '投标保函', type: 'bid' }, { name: '诉讼保全担保', type: 'dlProcess' }, { name: '工程数智 AI 大模型', type: 'ai' }] },
        { name: '案例介绍', routerName: '/caseIntroduction' },
        { name: '关于我们', routerName: '/aboutUs' }
      ],
      activeIndex: '/home',
      navItem: {},
      isShowNav: false, // 是否展示导航栏
      isSubassembly: false,
      mouseLeaveTmieout: null,
      isMouseShowNav: false // 是否展示移动端导航栏
    }
  },
  watch: {
    // 当路由变化时，更新 activeIndex
    '$route'(to) {
      this.activeIndex = to.path
    }
  },
  mounted() {
    // 页面加载时设置 activeIndex 为当前路由的路径
    this.activeIndex = this.$route.path
  },
  methods: {
    handleSelect(index) {
      // 当菜单项被选中时触发的操作，可以根据需要在这里处理
      console.log('Selected menu item:', index)
    },
    // 进入盒子事件
    handleMouseOver(item) {
      if (this.mouseLeaveTmieout) {
        clearTimeout(this.mouseLeaveTmieout)
      }
      this.isShowNav = item.routerUrl === '/businessIntroduction'
      this.navItem = item
    },
    // 子组件状态变更
    changeNav(is, item) {
      this.isSubassembly = is
      this.handleMouseLeave(item)
    },
    // 离开盒子事件
    handleMouseLeave(item) {
      if (item?.routerUrl === '/businessIntroduction') {
        this.mouseLeaveTmieout = setTimeout(() => {
        // 鼠标是否在子组件上
          if (this.isSubassembly) {
            return
          } else {
            this.isShowNav = false
          }
        }, 200)
      }
    },
    // 切换导航栏
    changMouseNav(type) {
      this.isMouseShowNav = type
    },
    // 点击前往新页面
    handleOpen(item) {
      // 等于这些子页面的type则是进入指定页面，否则直接跳转路由
      const navData = ['performance', 'bid', 'dlProcess', 'ai', 'gcztb']
      this.changMouseNav(false)
      if (navData.includes(item)) {
        if (item === 'dlProcess') {
          this.$router.replace({
            path: '/judicialbusiness',
            query: {
              type: item
            }
          })
          return
        }
        this.$router.replace({
          path: `/businessIntroduction/${item}`
        })
      } else {
        this.$router.replace({
          path: `${item}`
        })
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.head-conter-box {
  position: fixed;
  left: 0;
  top: 0;
  z-index: 888;
  width: 100%;
  min-width: 1280px;
  height: 60px;
  box-sizing: border-box;
  background: rgba(255, 255, 255, 0.1);
  font-family: PingFang SC, PingFang SC;

  .content_box {
    margin: auto;
    width: 1200px;
    display: flex;
    align-items: center;
    justify-content: space-between;

    .head-menu {
      width: 20px;
      height: 20px;
      font-size: 20px;
      color: #303133;
    }
  }

  &:hover {
    background: #FFFFFF;
    box-shadow: 0px 4px 12px 0px rgba(20, 97, 191, 0.04);
  }

  .el_menu_box {
    flex: 1;
    padding: 0 60px;
  }

  .logo-box {
    cursor: pointer;
    img {
      margin-right: 12px;
      vertical-align: middle;
      width: 20px;
      height: 20px;
    }

    span {
      color: $primary_black_color;
      font-weight: 400;
      font-size: 16px;
    }
  }

  ::v-deep {
    .el-menu {
      background: rgba(255, 255, 255, 0.1);

    }

    .el-menu-item {
      background-color: transparent !important;

    }

    .el-menu.el-menu--horizontal {
      border: none;
    }

    .el-button {
      border-radius: 0;
    }

    .is-active {
      border-bottom-color: transparent !important;
    }
  }

  .el_menu_box {
    position: relative;

  }

  .mouseNav-box {
    position: relative;
    top: 0px;
    left: 0px;
    width: 100%;
    height: calc(100vh - 47px);
    z-index: 10000;
    background-color: #FFFFFF;
    .mouse-menu {
      .el-menu-item {
        border-bottom: 1px solid #E5E6EB !important;
        height: 56px;
        padding: 0 16px !important;
        span {
          font-size: 16px;
          color: #1D2129;
          line-height: 24px;
        }
      }
      // .is-active {
      //   span {
      //     color: #409EFF;
      //   }
      // }
    }
    ::v-deep {
      .el-submenu__title {
        border-bottom: 1px solid #E5E6EB !important;
        .el-submenu__icon-arrow {
          font-size: 20px;
          color: #606266;
        }
        span {
          font-size: 16px;
          color: #1D2129;
          line-height: 24px;
        }
      }
      .el-menu-item-group {
        padding-left: 40px;
        .el-menu-item-group__title {
          display: none;
        }
        .el-menu-item {
          padding-left: 0px !important;
          font-size: 16px;
          color: #1D2129;
        }
      }
    }
  }
}
</style>
